




















import Vue from 'vue'
import Block from '@/components/Block.vue'

export default Vue.extend({
  name: 'ContentDialog',
  components: {
    Block,
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
    },
  },
  data: () => ({}),
})
